import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { HeaderContent } from 'components/Dashboards/Project/Components/DataStories/DataStoriesHeader/headerContent';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';

import classes from './dataStoriesHeader.module.scss';

const DataStoriesHeader = ({
    pageTitle,
    addStory,
    handleDateData,
    handleClearDate,
    onTextSearch,
    onClearSearch,
    isReadOnly = false,
    showTreeTopHeader,
    startDate,
    endDate,
}) => {
    return showTreeTopHeader ? (
        <TreeProgramTopHeader versionSelectorEnabled={false} pageTitle={pageTitle} showAll={true}>
            <HeaderContent
                isReadOnly={isReadOnly}
                addStory={addStory}
                handleDateData={handleDateData}
                handleClearDate={handleClearDate}
                onTextSearch={onTextSearch}
                onClearSearch={onClearSearch}
                startDate={startDate}
                endDate={endDate}
            />
        </TreeProgramTopHeader>
    ) : (
        <>
            <div className={classes.container}>
                <div className={classes.programTopHeader}>
                    <ProgramTopHeader pageTitle={executionConfig.dataStories.title} />
                    <Link
                        to={AppRoutes.buildPath(AppRoutes.DASHBOARD_EXECUTION_PATH, executionConfig.dataStories.link)}
                        className={classes.link}
                    >
                        Open Project Level News Feed
                    </Link>
                </div>
                <HeaderContent
                    isReadOnly={isReadOnly}
                    addStory={addStory}
                    handleDateData={handleDateData}
                    handleClearDate={handleClearDate}
                    onTextSearch={onTextSearch}
                    onClearSearch={onClearSearch}
                    startDate={startDate}
                    endDate={endDate}
                />
            </div>
        </>
    );
};

export default DataStoriesHeader;
